export default "__VITE_ASSET__Qt0D8_SL__"